import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import responsiveFontSizes from '@material-ui/core/styles/responsiveFontSizes';

import breakpoints from './breakpoints';
import overrides from './overrides';
import palette from './palette';
import props from './props';
import typography from './typography';
import variables from './variables';

export const theme = responsiveFontSizes(createMuiTheme({
  palette,
  variables,
  overrides,
  props,
  typography,
  breakpoints
}));